export default __webpack_public_path__ + "static/media/expedition-team-bg-2.94091464.png";